<script>
import Layout from '@/router/layouts/auth';
import { api } from '@/state/services';
import { mapState, mapActions } from 'vuex';
import { required, email, minLength } from 'vuelidate/lib/validators';
import axios from 'axios'
import Languages from '@/components/widgets/languages';
import { checkCpf } from '@/state/validations/register';
import Password from '@/components/widgets/input-password';

export default {
  locales: {
    pt: {
      'Choose your package': 'Escolha seu pacote',
      'Congratulations!': 'Parabéns!',
      'Your account has been successfully created.': 'Sua conta foi criada com sucesso.',
      'Sponsor': 'Patrocinador',
      'Sponsor is required.': 'Patrocinador é obrigatório.',
      'Ambassador': 'Embaixador',
      'Ambassador is required.': 'Embaixador é obrigatório.',

      'Name': 'Nome',
      'Name is required.': 'Nome é obrigatório.',
      'CPF': 'CPF',
      'CPF is required.': 'CPF é obrigatório.',
      'E-mail': 'E-mail',
      'E-mail is required.': 'E-mail é obrigatório.',
      'This value should be a valid e-mail.': 'Este valor deve ser um e-mail válido.',
      'Cellphone': 'Celular',
      'Cellphone is required.': 'Celular é obrigatório.',

      'Zipcode': 'Cep',
      'Zipcode is required.': 'Cep é obrigatório.',
      'Address': 'Endereço',
      'Address is required.': 'Endereço é obrigatório.',
      'Number': 'Número',
      'Number is required.': 'Número é obrigatório.',
      'Complement': 'Complemento',
      'Complement is required.': 'Complemento é obrigatório.',
      'District': 'Bairro',
      'District is required.': 'Bairro é obrigatório.',
      'City': 'Cidade',
      'City is required.': 'Cidade é obrigatório.',
      'State': 'Estado',
      'State is required.': 'Estado é obrigatório.',

      'Password': 'Senha',
      'Register': 'Cadastrar',
      'Click here to login': 'Clique aqui para fazer o login',
      'Already have an account?': 'Já possui uma conta?',
      'Login': 'Login',

      'The sponsor was not found.': 'O patrocinador não foi encontrado.',
      'Fill in all required fields.': 'Preencha todos os campos obrigatórios.',

      'The CPF entered is invalid.': 'O CPF digitado é inválido.',
      'The CPF is incorrect or is already being used.': 'O CPF digitado é inválido ou já está sendo utilizado.',
    },
    es: {
      'Choose your package': 'Elige tu paquete',
      'Congratulations!': '¡Felicidades!',
      'Your account has been successfully created.': 'Tu cuenta ha sido creada satisfactoriamente.',
      'Sponsor': 'Patrocinador',
      'Sponsor is required.': 'Se requiere patrocinador.',
      'Ambassador': 'Embaixador',
      'Ambassador is required': 'Embaixador é obrigatório',

      'Name': 'Nombre',
      'Name is required.': 'Se requiere el nombre.',
      'CPF': 'CPF',
      'CPF is required.': 'Se requiere CPF.',
      'E-mail': 'E-mail',
      'E-mail is required.': 'Se requiere correo electrónico.',
      'This value should be a valid e-mail.': 'Este valor debe ser un correo electrónico válido.',
      'Cellphone': 'Celular',
      'Cellphone is required.': 'Se requiere celular.',

      'Zipcode': 'Cep',
      'Zipcode is required.': 'Cep é obrigatório.',
      'Address': 'Endereço',
      'Address is required.': 'Endereço é obrigatório.',
      'Number': 'Número',
      'Number is required.': 'Número é obrigatório.',
      'Complement': 'Complemento',
      'Complement is required.': 'Complemento é obrigatório.',
      'District': 'Bairro',
      'District is required.': 'Bairro é obrigatório.',
      'City': 'Cidade',
      'City is required.': 'Cidade é obrigatório.',
      'State': 'Estado',
      'State is required.': 'Estado é obrigatório.',

      'Password': 'Contraseña',
      'Register': 'Registro',
      'Click here to login': 'Haga clic aquí para ingresar',
      'Already have an account?': '¿Ya tienes una cuenta?',
      'Login': 'Iniciar Sesión',

      'The sponsor was not found.': 'El patrocinador no fue encontrado.',
      'Fill in all required fields.': 'Rellene todos los campos obligatorios.',

      'The CPF entered is invalid.': 'El CPF ingresado no es válido.',
      'The CPF is incorrect or is already being used.': 'O CPF digitado é inválido ou já está sendo utilizado.',
    }
  },
  components: { Layout, Languages, Password },
  data() {
    return {
      loading: {
        register: false,
      },
      success: false,
      country: {
        abbr: "BR",
        code: "55",
        name: "Brazil",
        mask: "+55.###############",
      },
      countries: {},
      sponsor: {
        status: false,
        name: '',
        avatar: '',
        indication: '',
      },
      user: {
        country: "",
        sponsor: "",
        name: "",
        birthday: "",
        cpf: "",
        email: "",
        cellphone: "",
        zipcode: "",
        address: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        password: "",
        terms: {
          geral: false,
          auction: false,
          bonus: false,
          condition: false,
          policy: false,
        }
      },
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  validations: {
    user: {
      country: { },
      sponsor: { },
      name: { required },
      birthday: { required },
      cpf: { required, checkCpf },
      email: { required, email },
      cellphone: { required },
      zipcode: { required },
      address: { required },
      number: { required },
      complement: { },
      district: { required },
      city: { required },
      state: { required },
      password: { required, minLength: minLength(6) },
      terms: {
        geral: { required },
      }
    }
  },
  methods: {
    ...mapActions("account", ["register", "token"]),
    getCountries() {
      api
        .get('country')
        .then(response => {
          if (response.data.status=='success') {
            this.countries = response.data.list
          }
        })
    },
    getSponsor() {
      if (this.user.sponsor != this.sponsor.indication) {
        this.sponsor.name = ''
        this.sponsor.indication = this.user.sponsor
        this.sponsor.avatar = ''

        api
          .post('user/sponsor', {
            indication: this.user.sponsor
          })
          .then(response => {
            if (response.data.status=='error') {
              this.sponsor.status = false
              this.sponsor.name = ''
              this.sponsor.avatar = ''


              this.$router.push('/register')
            } else {
              this.sponsor.status = true
              this.sponsor.name = response.data.user.name
              this.sponsor.avatar = response.data.user.avatar

              localStorage.sponsor = JSON.stringify(response.data.user)

              this.$router.push('/register/' + response.data.user.indication)
            }
          })
      }
    },
    registerSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { name, birthday, cpf, email, cellphone, zipcode, address, number, district, city, state, password } = this.user;
        if (name && birthday && cpf && email && cellphone && zipcode && address && number && district && city && state && password) {
          this.loading.register = true
          api
            .post('user', {
              sponsor: this.user.sponsor,
              name: this.user.name,
              birthday: this.user.birthday,
              cpf: this.user.cpf,
              email: this.user.email,
              cellphone: this.user.cellphone,
              zipcode: this.user.zipcode,
              address: this.user.address,
              number: this.user.number,
              complement: this.user.complement,
              district: this.user.district,
              city: this.user.city,
              state: this.user.state,
              password: this.user.password,
            })
            .then(response => {
              if (response.data.status=='success') {
                this.user.sponsor = ''
                this.user.name = ''
                this.user.birthday  = '';
                this.user.cpf = ''
                this.user.email = ''
                this.user.cellphone = ''
                this.user.zipcode = ''
                this.user.address = ''
                this.user.number = ''
                this.user.complement = ''
                this.user.district = ''
                this.user.city = ''
                this.user.state = ''
                this.user.password = ''
                this.$v.$reset()

                this.alert.type = 'alert-success'
                this.alert.message = response.data.message

                this.success = true
              } else {
                this.alert.type = 'alert-danger'
                this.alert.message = response.data.message
              }

              this.loading.register = false
            })
            .catch(error => {
              if (error) {
                this.loading.register = false
              }
            })
            .finally(() => {
              this.loading.register = false
            })
        }

      }
    },
		searchCep () {
			if (this.user.zipcode.length == 9) {
				axios.get('https://viacep.com.br/ws/' + this.user.zipcode + '/json')
				.then(response => {
          this.user.address = response.data.logradouro
          this.user.district = response.data.bairro
          this.user.city = response.data.localidade
          this.user.state = response.data.uf
        })
			}
		}
  },
  mounted() {
    if (this.$route.params.sponsor) {
      this.user.sponsor = this.$route.params.sponsor

      api
        .post('user/sponsor', {
          indication: this.user.sponsor
        })
        .then(response => {
          if (response.data.status=='error') {
            this.sponsor.status = false
            this.sponsor.name = ''
            this.sponsor.avatar = ''
            this.$router.push('/register')
          } else {
            this.sponsor.status = true
            this.sponsor.name = response.data.user.name
            this.sponsor.indication = response.data.user.indication
            this.sponsor.avatar = response.data.user.avatar

            localStorage.sponsor = JSON.stringify(response.data.user)
          }
        })
    }

    if (!this.user.sponsor) {
      if (localStorage.sponsor) {
        this.user.sponsor = JSON.parse(localStorage.sponsor).indication
        this.getSponsor()
      }
    }

    this.getCountries()
  },
  watch: {
    'user.country': function (value) {
      this.country = this.countries[value]
      this.country.mask = '+' + this.countries[value].code + '.###############'
    }
  }
};
</script>

<template>
  <Layout>
    <div
      id="auth"
      class="d-flex"
    >
      <div class="login-content">
        <div class="pt-5 pb-3">
          <router-link class="align-middle" tag="a" to="/">
            <img
              class="w-100"
              style="max-width: 200px"
              src="@/assets/images/logo.png"
            />
          </router-link>
        </div>
        <div class="py-4">
          <div v-if="success" class="text-center pt-4 pb-4">
            <h5>{{ t('Congratulations!') }}<br>{{ t('Your account has been successfully created.') }}</h5>
          </div>
          <div v-else>
            <div v-if="alert.message" :class="'alert ' + alert.type">{{ t(alert.message) }}</div>
            <b-form @submit.prevent="registerSubmit">
              <div class="divisor mb-3">
                <span>Dados Pessoais</span>
              </div>

              <b-form-group id="name-group" :label="t('Name')" label-for="name">
                <b-form-input id="name" v-model="user.name" type="text" :class="{ 'is-invalid': $v.user.name.$error }"></b-form-input>
                <div v-if="!$v.user.name.required" class="invalid-feedback">{{ t('Name is required.') }}</div>
              </b-form-group>
              <b-form-group id="birthday-group" :label="t('Data de Nascimento')" label-for="birthday">
                <b-form-input id="birthday" v-model="user.birthday" v-mask="'##/##/####'" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.user.birthday.$error }"></b-form-input>
                <div v-if="$v.user.birthday.$error" class="invalid-feedback">
                  <span v-if="!$v.user.birthday.required">{{ t('Birthday is required.') }}</span>
                </div>
              </b-form-group>
              <b-form-group id="cpf-group" :label="t('CPF')" label-for="cpf">
                <b-form-input id="cpf" v-model="user.cpf" type="text" :class="{ 'is-invalid': $v.user.cpf.$error }" v-mask="'###.###.###-##'"></b-form-input>
                <div v-if="!$v.user.cpf.required" class="invalid-feedback">{{ t('CPF is required.') }}</div>
                <div v-if="!$v.user.cpf.checkCpf" class="invalid-feedback">{{ t('The CPF entered is invalid.') }}</div>
              </b-form-group>
              <b-form-group id="email-group" :label="t('E-mail')" label-for="email">
                <b-form-input id="email" v-model="user.email" type="email" :class="{ 'is-invalid': $v.user.email.$error }"></b-form-input>
                <div v-if="$v.user.email.$error" class="invalid-feedback">
                  <span v-if="!$v.user.email.required">{{ t('E-mail is required.') }}</span>
                  <span v-if="!$v.user.email.email">{{ t('This value should be a valid e-mail.') }}</span>
                </div>
              </b-form-group>
              <b-form-group id="cellphone-group" :label="t('Cellphone')" label-for="cellphone">
                <!-- <select v-model="user.country" class="custom-select mb-1">
                  <option v-for="(option,index) in countries" :key="index" :value="option.abbr">{{ option.abbr + ' ' + option.name + ' +' + option.code }}</option>
                </select> -->
                <b-input-group :prepend="country.abbr + ' +' + country.code" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input id="cellphone" v-model="user.cellphone" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.user.cellphone.$error }" v-mask="country.mask"></b-form-input>
                </b-input-group>
                <div v-if="!$v.user.cellphone.required" class="invalid-feedback">{{ t('Cellphone is required.') }}</div>
              </b-form-group>

              <div class="divisor mb-3">
                <span>Dados de Endereço</span>
              </div>

              <b-form-group id="zipcode-group" :label="t('Zipcode')" label-for="zipcode">
                <b-form-input id="zipcode" v-model="user.zipcode" type="text" inputmode="numeric" :class="{ 'is-invalid': $v.user.zipcode.$error }" v-mask="'#####-###'" @keyup="searchCep()"></b-form-input>
                <div v-if="!$v.user.zipcode.required" class="invalid-feedback">{{ t('Zipcode is required.') }}</div>
              </b-form-group>
              <b-form-group id="address-group" :label="t('Address')" label-for="address">
                <b-form-input id="address" v-model="user.address" type="text" :class="{ 'is-invalid': $v.user.address.$error }"></b-form-input>
                <div v-if="!$v.user.address.required" class="invalid-feedback">{{ t('Address is required.') }}</div>
              </b-form-group>
              <b-form-group id="number-group" :label="t('Number')" label-for="number">
                <b-form-input id="number" v-model="user.number" type="text" :class="{ 'is-invalid': $v.user.number.$error }"></b-form-input>
                <div v-if="!$v.user.number.required" class="invalid-feedback">{{ t('Number is required.') }}</div>
              </b-form-group>
              <b-form-group id="complement-group" :label="t('Complement')" label-for="complement">
                <b-form-input id="complement" v-model="user.complement" type="text" :class="{ 'is-invalid': $v.user.complement.$error }"></b-form-input>
                <div v-if="!$v.user.complement.required" class="invalid-feedback">{{ t('Complement is required.') }}</div>
              </b-form-group>
              <b-form-group id="district-group" :label="t('District')" label-for="district">
                <b-form-input id="district" v-model="user.district" type="text" :class="{ 'is-invalid': $v.user.district.$error }"></b-form-input>
                <div v-if="!$v.user.district.required" class="invalid-feedback">{{ t('District is required.') }}</div>
              </b-form-group>
              <b-form-group id="city-group" :label="t('City')" label-for="city">
                <b-form-input id="city" v-model="user.city" type="text" :class="{ 'is-invalid': $v.user.city.$error }"></b-form-input>
                <div v-if="!$v.user.city.required" class="invalid-feedback">{{ t('City is required.') }}</div>
              </b-form-group>
              <b-form-group id="state-group" :label="t('State')" label-for="state">
                <b-form-input id="state" v-model="user.state" type="text" :class="{ 'is-invalid': $v.user.state.$error }" v-mask="'XX'"></b-form-input>
                <div v-if="!$v.user.state.required" class="invalid-feedback">{{ t('State is required.') }}</div>
              </b-form-group>

              <div class="divisor mb-3">
                <span>Dados de Acesso</span>
              </div>

              <b-form-group id="password-group" :label="t('Password')" label-for="password">
                <Password v-model="user.password" :v="$v.user.password"></Password>
              </b-form-group>

              <div class="mt-4">
                <b-button :disabled="loading.register == true" type="submit" variant="default" class="btn-lg btn-block">
                  {{ t('Register') }}
                  <b-spinner v-if="loading.register" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
          <div class="mt-4">
            <p class="text-dark">
              {{ t("Already have an account?") }}
              <router-link
                tag="a"
                to="/login"
                class="font-weight-medium text-muted"
                >{{ t("Login") }}</router-link
              >
            </p>
            <Languages class="d-none" type="dropup"></Languages>
            <div v-if="sponsor.status && sponsor.name" class="mb-4">
              <span class="text-uppercase font-size-11 text-muted"
                ><small>REF. {{ sponsor.indication }}</small></span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>

<style scoped>
.label-description {
  margin: -10px 0 10px 0;
}
.divisor {
  position: relative;
  text-align: center;
  text-transform: uppercase;
}
.divisor span {
  display: inline-block;
  padding: 0 5px;
  background: #fff;
  font-size: 10px;
  letter-spacing: 2px;
  color: #888;
}
.divisor:before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
  top: 52%;
  height: 1px;
  background: #ccc;
}
</style>